<div class="dialog small">
  <div class="dialog-close" [mat-dialog-close]="false"></div>
  <h3 class="dialog-title" data-testid="dialog-title">
    {{ data?.title }}
  </h3>
  @if (data?.subtitle) {
    <div class="dialog-content2 mb-4">
      {{ data.subtitle }}
    </div>
  }
  <div class="dialog-actions single">
    <button class="btn btn-primary" data-testid="close-modal" (click)="onClose($event)">
      {{ 'shared.close' | translate }}
    </button>
  </div>
</div>
